import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";



import HospitalUserLoginLogs from "../../HospitalPages/HospitalSecurityAudit/HospitalUserLoginLogs";
import HospitalRolePermissionManagement from "../../HospitalPages/HospitalSecurityAudit/HospitalRolePermissionManagement";
import HospitalAPITokenManagement from "../../HospitalPages/HospitalSecurityAudit/HospitalAPITokenManagement";
import HospitalAuditTrails from "../../HospitalPages/HospitalSecurityAudit/HospitalAuditTrails";
import { decrypt } from "../../components/cryptoUtil";
import DashboardCards from "../HospitalDashBoardCards";
import { includeCardForRoles, ROLES } from "../componenet/heading";


const HospitolSecurityAuditDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const tokenData = localStorage.getItem("tokenData");
  const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  const userName = decryptedData.userfullname || "";
  const userRole = decryptedData.userrole || "";


  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  const cardRoles = {
    "User Login Logs": [ROLES.RECEPTIONIST], // only userRole 101 can see
    "Role Permission Management": [ROLES.RECEPTIONIST],   // only userRole 102 can see
    "API Tokens Management": [ROLES.RECEPTIONIST],
    "Audit Trails": [ROLES.STAFF],
    
  };


  const cards = [
    ...includeCardForRoles(cardRoles["User Login Logs"], userRole,
      {
        title: "User Login Logs",
        icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
        component: <HospitalUserLoginLogs />, category: "👨‍⚕️ Hospitol Security Audit Data Management",
      }),
    ...includeCardForRoles(cardRoles["Role Permission Management"], userRole,
      {
        title: "Role Permission Management",
        icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
        component: <HospitalRolePermissionManagement />, category: "👨‍⚕️ Hospitol Security Audit Data Management",
      }),

    ...includeCardForRoles(cardRoles["API Tokens Management"], userRole,
      {
        title: "API Tokens Management",
        icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
        component: <HospitalAPITokenManagement />, category: "👨‍⚕️ Hospitol Security Audit Data Management",
      }),
    ...includeCardForRoles(cardRoles["Audit Trails"], userRole,
      {
        title: "Audit Trails",
        icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
        component: <HospitalAuditTrails />, category: "👨‍⚕️ Hospitol Security Audit Data Management",
      }),


  ];



  return (
    <DashboardCards
      cards={cards}
      menulabel={1}
      welcomeMessage={
        <Typography variant="h5" align="center" gutterBottom>
          👨‍⚕️ Welcome {userName}
        </Typography>
      }
    />
  );
};

export default HospitolSecurityAuditDashBoard;
